import { createTheme } from '@mui/material/styles';
import ComponentsOverrides from './overrides';

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1025,
      lg: 1200,
      xl: 1536,
    },
  },

  palette: {
    serviceMethodColors: {
      tts: { main: '#d2ff27' },
      ttr: { main: '#d2ff27' },
      cnc: { main: '#00c2ff' },
      cp:  { main: '#ffffff' },
      tableService: { main: '#00c2ff' },
      roomService: { main: '#00c2ff' },
    },
    black: '#2a2a2a',
  },
});


theme = createTheme(theme, {
  components: ComponentsOverrides(theme),
});

export default theme;

